'use strict';

module.exports = text;

var u = require('unist-builder');
var trimLines = require('trim-lines');

/* Transform text. */
function text(h, node) {
  return h.augment(node, u('text', trimLines(node.value)));
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/mdast-util-to-hast/lib/handlers/text.js
// module id = 978
// module chunks = 0